var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.519,
    height: 17.485,
    viewBox: "0 0 24.519 17.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_437",
    "data-name": "Grupo 437",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_591",
    "data-name": "Grupo 591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01,0h20.5a2.1,2.1,0,0,1,2.01,2.186V15.3a2.1,2.1,0,0,1-2.01,2.186H2.01A2.1,2.1,0,0,1,0,15.3V2.186A2.1,2.1,0,0,1,2.01,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.055446624755859 2.000000953674316 C 2.033531188964844 2.027084350585938 1.999998092651367 2.087823867797852 1.999998092651367 2.185590744018555 L 1.999998092651367 15.29915046691895 C 1.999998092651367 15.39691734313965 2.033531188964844 15.45765686035156 2.055446624755859 15.48474025726318 L 22.4633903503418 15.48474025726318 C 22.48530578613281 15.45765686035156 22.51883888244629 15.39691734313965 22.51883888244629 15.29915046691895 L 22.51883888244629 2.185590744018555 C 22.51883888244629 2.087823867797852 22.48530578613281 2.027084350585938 22.4633903503418 2.000000953674316 L 2.055446624755859 2.000000953674316 M 2.009738922119141 0 L 22.50909805297852 0 C 23.61904907226562 0 24.51883888244629 0.9785213470458984 24.51883888244629 2.185590744018555 L 24.51883888244629 15.29915046691895 C 24.51883888244629 16.5062198638916 23.61904907226562 17.4847412109375 22.50909805297852 17.4847412109375 L 2.009738922119141 17.4847412109375 C 0.8997879028320312 17.4847412109375 -1.9073486328125e-06 16.5062198638916 -1.9073486328125e-06 15.29915046691895 L -1.9073486328125e-06 2.185590744018555 C -1.9073486328125e-06 0.9785213470458984 0.8997879028320312 0 2.009738922119141 0 Z",
    stroke: "none",
    fill: "#18a9e9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    "data-name": "Trazado 279",
    d: "M0,0H24.334",
    transform: "translate(0.128 5.2)",
    fill: "none",
    stroke: "#18a9e9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    "data-name": "L\\xEDnea 18",
    x2: 14.597,
    transform: "translate(7.203 8.173)",
    fill: "none",
    stroke: "#7fc0c6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_438",
    "data-name": "Grupo 438",
    transform: "translate(2.793 11.463)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_27",
    "data-name": "Elipse 27",
    cx: 1.426,
    cy: 1.426,
    r: 1.426,
    fill: "#fbb500"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_28",
    "data-name": "Elipse 28",
    cx: 1.426,
    cy: 1.426,
    r: 1.426,
    transform: "translate(2.194)",
    fill: "#fbb500"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_21",
    "data-name": "L\\xEDnea 21",
    x2: 6.488,
    transform: "translate(14.232 10.727)",
    fill: "none",
    stroke: "#7fc0c6",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.b602ebd33c105b17389abcd7ce2fe0fa.svg";
export { ForwardRef as ReactComponent };